module.exports = __webpack_public_path__ + "img/pic_dapp_icon.1718cd73.svg";